export const accordion = {
  name: 'vch-accordion',
  inserted: (el, binding) => {
    const animationSpeed = 300;
    const animationEasing = 'ease-out';
    const collapseAttribute = 'data-collapse';

    let accordionGroup = null;
    let animation = null;
    el.isClosing = false;
    let isExpanding = false;
    const summary = el.querySelector('summary');
    const content = el.querySelector('.vchy-details__contents');

    if (binding.value?.group) {
      accordionGroup = binding.value?.group;
    }

    const closeOtherAccordions = () => {
      if (accordionGroup === null) return;
      const matches = document.querySelectorAll(
        `[data-accordion-group='${accordionGroup}']`
      );

      matches.forEach(function (acord) {
        if (acord !== el) {
          acord.setAttribute(collapseAttribute, true);
        }
      });
    };

    const onAnimationFinish = (isOpen) => {
      el.open = isOpen;
      animation = null;
      el.isClosing = false;
      isExpanding = false;
      el.style.height = el.style.overflow = '';
    };

    const expand = () => {
      isExpanding = true;
      const startHeight = `${el.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

      if (animation) {
        animation.cancel();
      }

      // Start a WAAPI animation
      animation = el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: animationSpeed,
          easing: animationEasing,
        }
      );

      animation.onfinish = () => onAnimationFinish(true);
      animation.oncancel = () => (isExpanding = false);
    };

    const open = () => {
      el.style.height = `${el.offsetHeight}px`;
      el.open = true;
      el.querySelector('summary').setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => expand());
    };

    const shrink = () => {
      el.isClosing = true;
      const startHeight = `${el.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight}px`;

      if (animation) {
        animation.cancel();
      }

      // Start a WAAPI animation
      animation = el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: animationSpeed,
          easing: animationEasing,
        }
      );

      animation.onfinish = () => onAnimationFinish(false);
      animation.oncancel = () => (el.isClosing = false);
    };

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      closeOtherAccordions();
      el.style.overflow = 'hidden';
      if (el.isClosing || !el.open) {
        open();
      } else if (isExpanding || el.open) {
        shrink();
      }
    });

    el.observer = new MutationObserver(function (mutationsList) {
      if (
        mutationsList.length === 1 &&
        mutationsList[0].attributeName === collapseAttribute &&
        el.getAttribute(collapseAttribute) &&
        (isExpanding || el.open)
      ) {
        el.style.overflow = 'hidden';
        shrink();
        el.removeAttribute(collapseAttribute);
      }
    });

    el.observer.observe(el, { attributes: true });
  },
  unbind(el) {
    el.observer.disconnect();
  },
};
